// extracted by mini-css-extract-plugin
export default {"keyInfoContainer":"keyInfo_keyInfoContainer__V+j27","fRow":"keyInfo_fRow__Nw-rB","item":"keyInfo_item__q3Nql","title":"keyInfo_title__shUXf"};